import React, { Fragment, useState, useEffect, useContext, useRef } from 'react'
import ReactGA from 'react-ga'
import Cookies from 'js-cookie'
import { get, set } from 'idb-keyval'
// we shim an implementation of "next/dynamic" in DS9 in webpack
// we HAVE to use magic comments https://loadable-components.com/docs/babel-plugin/#magic-comments
import dynamic from 'next/dynamic'
import useWindow from 'Hooks/useWindow'
//import EmailSignUpModalContent from './EmailSignUpModalContent'
import { NavigationContext } from 'Contexts/Navigation/NavigationContext'

import { UserContext } from 'Contexts/UserContext/UserContext'
import { NotificationContext } from '../../Contexts/NotificationContext/NotificationContext'
import useSegmentLeadCaptureEvent from '../../Hooks/useSegment/segmentSpecificHooks/useSendLeadCaptureEvent'
import useSegment from '../../Hooks/useSegment/useSegment'

// we shim an implementation of "next/dynamic" in DS9 in webpack
// we HAVE to use magic comments https://loadable-components.com/docs/babel-plugin/#magic-comments
const EmailSignUpModalContent = dynamic(/* #__LOADABLE__ */() => import('./EmailSignUpModalContent'))

const hasDisplayedModalKey = 'EmailSignupModal_HasDisplayedPreviously'
const lastPageViewedKey = 'EmailSignupModal_LastPageViewed'
const numberOfPagesViewedKey = 'EmailSignupModal_NumberOfPagesViewed'

const EmailSignUpModal = (disabledPathNames) => {
    const { sendEmailEvent, sendSmsEvent } = useSegmentLeadCaptureEvent();


    const { state: navigationState, dispatch: navigationDispatch } = useContext(NavigationContext)
    const [isOpen, setIsOpen] = useState(false)
    const modal = useRef(null)
    let showModal = true
    const { DismissAllNotifications } = useContext(NotificationContext)

    useEffect(() => {
        const { email } = navigationState;
        setIsOpen(email?.isEmailSignupModalOpen ?? false)
        if (email?.isEmailSignupModalOpen) {
            DismissAllNotifications()
            set(hasDisplayedModalKey, true)
            sendEmailEvent("Impression", "gobal signup modal");
            sendSmsEvent("Impression", "gobal signup modal");
            ReactGA.event({
                category: 'Email Engagement',
                action: 'Modal',
                label: 'Displayed Modal',
                nonInteraction: true,
            })
        }
    }, [navigationState])

    const handleNavigationChange = (value) => navigationDispatch({
        type: 'setEmailState',
        payload: {
            emailState: {
                isEmailSignupModalOpen: value
            }
        }
    })

    useWindow((window) => {
        if (window.location.href.includes('/buy')) showModal = false
        else if (window.location.href.includes('/emailsignup')) showModal = false
        else if (
            disabledPathNames &&
            disabledPathNames.length &&
            disabledPathNames.some(
                (pathname) => pathname && window && window.location.pathname && pathname.toLowerCase() === window.location.pathname.toLowerCase()
            )
        )
            showModal = false
    })
    const { context: customerState } = useContext(UserContext)
    useEffect(() => {
        const isUserLoggedIn = customerState.isRegistered
        get(hasDisplayedModalKey).then((hasDisplayedModal) => {
            if (showModal && !hasDisplayedModal && !isUserLoggedIn) {
                const currentPage = document.location.pathname
                const isCurrentPageShoppingCart = new RegExp('^/shoppingcart/?$', 'i').test(currentPage)
                const isCurrentPageLayoutPage = new RegExp('^/ds9layout/?$', 'i').test(currentPage)
                get(lastPageViewedKey).then((lastPageViewed) => {
                    get(numberOfPagesViewedKey).then((numberOfPagesViewedValue) => {
                        let numberOfPagesViewed = parseInt(numberOfPagesViewedValue) || 0
                        if (lastPageViewed != currentPage) {
                            set(lastPageViewedKey, window.location.href)
                            set(numberOfPagesViewedKey, numberOfPagesViewed ? ++numberOfPagesViewed : 1)
                        }

                        let modalTimeout = 25005
                        if (isCurrentPageShoppingCart) {
                            modalTimeout = 0
                        } else if (isCurrentPageLayoutPage) {
                            modalTimeout = 30000
                        } else if (numberOfPagesViewed >= 2) {
                            modalTimeout = 2001
                        }

                        setTimeout(function () {
                            if (!(window.$crisp?.is('chat:opened') ?? false)) {
                                handleNavigationChange(true)
                            }

                        }, modalTimeout)
                    })
                })
            }
        })
    }, [typeof document])

    return (
        <Fragment>
            {isOpen ?
                <EmailSignUpModalContent sendEmailEvent={sendEmailEvent} sendSmsEvent={sendSmsEvent} ref={modal} />
                : false}
        </Fragment>
    )
}
export default EmailSignUpModal
